import { type PlatformEvent } from '../types';

export const makeShareEvent = (source: string, hasSent?: boolean): PlatformEvent => {
  return {
    type: 'click',
    created: Date.now(),
    user_properties: {},
    event_properties: {
      name: 'share_button_click',
      event_source: source,
      hasSent,
    },
  };
};
